type TwoColumnWidgetLayoutInput = {
  firstChildLowerWidthLimit: number;
  firstChildUpperWidthLimit: number;
  firstChildWidth: number;
  numberOfColumnsInWidget: number;
};

type TwoColumnWidgetLayout = {
  firstChildFlex: number;
  secondChildFlex: number;
  shouldFirstChildRender: boolean;
  shouldSecondChildRender: boolean;
};

export const getTwoColumnWidgetLayout = ({
  firstChildLowerWidthLimit,
  firstChildUpperWidthLimit,
  firstChildWidth,
  numberOfColumnsInWidget,
}: TwoColumnWidgetLayoutInput): TwoColumnWidgetLayout => {
  const shouldFirstChildRender =
    numberOfColumnsInWidget <= firstChildLowerWidthLimit ||
    numberOfColumnsInWidget > firstChildUpperWidthLimit;

  const shouldSecondChildRender = numberOfColumnsInWidget > firstChildLowerWidthLimit;

  return {
    firstChildFlex: firstChildWidth,
    secondChildFlex: numberOfColumnsInWidget - firstChildWidth,
    shouldFirstChildRender,
    shouldSecondChildRender,
  };
};
